module.exports = __webpack_public_path__ + "static/media/hue.21f564d9.mp4";